import { Brand, BrandKey } from "./types";

/**
 * Brand definitions. Palette values are kept in sync with the MUI theme files at
 * `apps/mtc-provider-app/src/theme/{mtc,teleheadache}/theme.ts`.
 */
export const BRANDS: Record<BrandKey, Brand> = {
  // The go-forward CerebraLinked deployment (portal.cerebralinked.com). Its own key + assets so it
  // is self-contained; the legacy "mtc" key below is the same identity and is retired once
  // mtc.teleheadache.com is sunset.
  cerebralinked: {
    key: "cerebralinked",
    product: "cerebralinked",
    displayName: "CerebraLinked",
    shortName: "CerebraLinked",
    legalName: "CerebraLinked LLC",
    copyrightHolder: "CerebraLinked LLC",
    carePlanName: "CerebraLinked Care Plan",
    logo: "/images/cerebralinked-logo.svg",
    logoSmall: "/images/cerebralinked-logo.svg",
    logoWhite: "/images/cerebralinked-logo-white.svg",
    heroLogo: "/images/cerebralinked-hero.png",
    favicon: "/favicon.cerebralinked.ico",
    appleTouchIcon: "/apple-touch-icon-cerebralinked.png",
    manifest: "/manifest.cerebralinked.json",
    websiteUrl: "https://www.cerebralinked.com",
    themeColor: "#16BCC0",
    palette: {
      primary: {
        light: "#22D3D6",
        main: "#16BCC0",
        dark: "#0B8385",
        contrastText: "#04141C",
      },
      secondary: {
        light: "#3FA3CC",
        main: "#1E7CAD",
        dark: "#0D4C6B",
        contrastText: "#ffffff",
      },
      background: { default: "#EEF6F7", paper: "#FFFFFF" },
    },
  },
  mtc: {
    // Legacy deployment key (mtc.teleheadache.com). Same public identity as `cerebralinked`;
    // retire this key when that deployment is sunset.
    key: "mtc",
    product: "cerebralinked",
    displayName: "CerebraLinked",
    shortName: "CerebraLinked",
    legalName: "CerebraLinked LLC",
    copyrightHolder: "CerebraLinked LLC",
    carePlanName: "CerebraLinked Care Plan",
    logo: "/images/mtc-logo.svg",
    logoSmall: "/images/mtc-logo.svg",
    logoWhite: "/images/mtc-logo-white.svg",
    heroLogo: "/images/cerebralinked-hero.png",
    favicon: "/favicon.cerebralinked.ico",
    appleTouchIcon: "/apple-touch-icon-cerebralinked.png",
    manifest: "/manifest.mtc.json",
    websiteUrl: "https://www.cerebralinked.com",
    // Same identity as `cerebralinked` — shares the CerebraLinked palette.
    themeColor: "#16BCC0",
    palette: {
      primary: {
        light: "#22D3D6",
        main: "#16BCC0",
        dark: "#0B8385",
        contrastText: "#04141C",
      },
      secondary: {
        light: "#3FA3CC",
        main: "#1E7CAD",
        dark: "#0D4C6B",
        contrastText: "#ffffff",
      },
      background: { default: "#EEF6F7", paper: "#FFFFFF" },
    },
  },
  th: {
    key: "th",
    product: "teleheadache",
    displayName: "TeleHeadache",
    shortName: "TeleHeadache",
    legalName: "TeleHeadache LLC",
    copyrightHolder: "TeleHeadache LLC",
    carePlanName: "TeleHeadache Care Plan",
    logo: "/images/Teleheadache.png",
    logoSmall: "/images/Teleheadache.png",
    logoWhite: "/images/TeleheadacheWhite.png",
    // Navy brain-T mark (2026-10-03). A new file name rather than overwriting favicon.ico, because
    // browsers cache favicons hard and keyed by URL.
    favicon: "/favicon.th.ico",
    appleTouchIcon: "/apple-touch-icon-th.png",
    manifest: "/manifest.th.json",
    websiteUrl: "https://www.teleheadache.com",
    termsUrl: "https://www.teleheadache.com/terms",
    privacyUrl: "https://www.teleheadache.com/privacy",
    // TeleHeadache Portal Brand & UI guide (2026-10-11): ink navy actions, teal accent, cloud
    // canvas. The web portal's TH light theme (src/theme/teleheadache/lightTheme.th.ts) matches.
    themeColor: "#0B1736",
    palette: {
      primary: {
        light: "#16395B",
        main: "#0B1736",
        dark: "#070F24",
        contrastText: "#ffffff",
      },
      secondary: {
        light: "#56D3CB",
        main: "#087D82",
        dark: "#055B61",
        contrastText: "#ffffff",
      },
      background: { default: "#FAFBFD", paper: "#FFFFFF" },
    },
  },
};
